import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getRoutes } from '../../constants/Routes';
import { getChatContacts, getContacts } from '../../redux/actions/contact';
import { decodeId, encodeId } from '../../utils/secureId';
import ChatItem from '../ChatItem';
import ContactModal from '../ContactModal';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spin } from 'antd';
import { store } from '../../redux/store';
import { setFilters } from '../../redux/slices/filtersSlice';

const ChatList = ({ isChat, filters }) => {
    const { userId: encUserId } = useParams();
    const userId = encUserId && decodeId(encUserId);
    const navigate = useNavigate();
    const { activeContacts, activeContactsPagination, chatContacts, chatContactsPagination } =
        useSelector((state) => state.contactsSlice);
    const [contact, setContact] = useState();
    const [loading, setLoading] = useState(false);
    const hasMore = isChat
        ? chatContactsPagination?.page < chatContactsPagination?.totalPages
        : activeContactsPagination?.page < activeContactsPagination?.totalPages;

    const handleNavigate = (id) => {
        const encodedId = encodeId(id);
        navigate({
            pathname: getRoutes().chat_detail.route(encodedId),
        });
    };

    const getMoreMessages = async () => {
        if (!loading) {
            setLoading(true);
            const res = isChat ?
                await getChatContacts({ ...filters, page: chatContactsPagination?.page + 1 }) :
                await getContacts({ ...filters, type: 'CHAT', status: 1, page: activeContactsPagination?.page + 1 });
            if (res?.ack) setLoading(false);

        }
    };

    useEffect(() => {
        store.dispatch(setFilters(null));

        if (isChat) {
            getChatContacts();
        } else {
            getContacts({ type: 'CHAT', status: 1 });
        }
    }, [isChat]);

    const listData = isChat ? chatContacts : activeContacts;

    return (
        <div className="chat-list" id="scrollableData">
            <InfiniteScroll
                dataLength={listData.length}
                next={getMoreMessages}
                hasMore={hasMore}
                scrollableTarget="scrollableData"
            >
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    style={{ overflow: 'hidden' }}
                >
                    {listData?.length ? (
                        listData?.map((user) => (
                            <ChatItem
                                isChat={isChat}
                                key={user.id}
                                user={user}
                                isActive={userId === user?.id}
                                onClick={() => handleNavigate(user?.id)}
                                onAddContact={(user) => setContact(user)}
                            />
                        ))
                    ) : (
                        <p className="empty">No Data</p>
                    )}
                    {loading && (
                        <div className="more-data">
                            <p>Loading...</p>
                            <Spin size="small" />
                        </div>
                    )}
                </motion.div>
            </InfiniteScroll>

            {contact && (
                <ContactModal
                    open={contact}
                    onCancel={() => setContact()}
                    data={contact}
                    isUnknownContact
                />
            )}
        </div>
    );
};

export default ChatList;
